let WS = {

  /**
   * @type WebSocket
   */
  websocket: undefined,

  listeners: {},

  /**
   * Ouvrir la connexion Websocket.
   * 
   * @param {Function} onOpen 
   * @param {Function} onClose 
   * @param {Function} onReconnect 
   */
  connect(onOpen, onClose, onReconnect){
    if(onOpen === undefined) onOpen = function(){ };
    if(onClose === undefined) onClose = function(){ };
    if(onReconnect === undefined) onReconnect = function(){ };

    if (window.WSUrl && window.WSUrl != '')
    {
      let websocket = this.websocket = new WebSocket(window.WSUrl);

      websocket.onopen = function (e) {
        console.log("Connection with WebSocket established!");
        $(".websocket-indicator").addClass("connected");
        $(".websocket-indicator").removeClass("disconnected");
        $(".websocket-indicator").attr("title", "Rafraîchissement automatique actif.");
        onOpen();
      };

      websocket.onmessage = function (e) {
        var msg = JSON.parse(e.data);
        console.log("WebSocket receiving:");
        console.log(msg);
        let except = msg.except ?? [];

        if(typeof except === 'number'){
          except = [except];
        }

        if(msg.data instanceof Array && msg.data.length == 0){
          msg.data = {};
        }

        if(msg.room_connections !== undefined){
          msg.data.room_connections = msg.room_connections;
        }

        WS.receive(msg.room, msg.data, except);
      }
      websocket.onclose = function () {
        console.log('Web Socket Connection Closed. Reconnecting...');
        $(".websocket-indicator").addClass("disconnected");
        $(".websocket-indicator").removeClass("connected");
        $(".websocket-indicator").attr("title", "Rafraîchissement automatique non disponible.")
        setTimeout(() => { WS.connect(onReconnect, onClose); }, 100);
        onClose();
      };

      window.addEventListener("beforeunload", () => {
        websocket.onclose = function () {}; // disable onclose handler first
        websocket.close();
        onClose();
      })

    }

  },

  /**
   * Déconnecter le Websocket.
   */
  disconnect() {
    if(this.websocket === undefined) return;
    this.websocket.close(0, "Disconnected normally."); 
  },

  /**
   * Recevoir les données.
   * 
   * @param {string} room 
   * @param {any} data 
   * @param {number[]} except 
   * @returns 
   */
  receive(room, data, except) {
    console.log("WebSocket receive");
    if(except.indexOf(window.randomBrowserId) !== -1){
      return;
    }

    if (this.listeners[room] !== undefined) {
      for (const listener of this.listeners[room]) {
        listener(data);
      }
    }
  },

  /**
   * Envoyer des données via le Websocket.
   * 
   * @param {string} room 
   * @param {any} data 
   * @param {boolean} includeSelf 
   * @returns 
   */
  send(room, data, includeSelf){
    console.log("WebSocket send");
    if(includeSelf === undefined) includeSelf = false;

    let websocket = this.websocket;

    if(websocket === undefined) {
      WS.connect(function() {
        WS.send(room, data, includeSelf)
      })
      return;
    }

    if(websocket.readyState == 1){
      websocket.send(JSON.stringify({ op: "broadcast", room: room, data: data }));
      if(includeSelf){
        WS.receive(room, data, []);
      }
    } else {
      console.warn("Cannot send data with WebSocket when not open.");
    }
  },

  /**
   * Joindre un salon de Websocket.
   * 
   * @param {string} room 
   * @param {Function} listener 
   * @returns 
   */
  join(room, listener) {
    console.log("WebSocket join");
    let websocket = this.websocket;

    if(websocket === undefined) {
      WS.connect(function() {
        WS.join(room, listener)
      })
      return;
    }

    if(this.websocket.readyState == 1){
      // only include user_name if defined and non-empty
      let payload = { op: "join", room: room };
      if (typeof window.WSUserName !== 'undefined' && window.WSUserName !== null && String(window.WSUserName).trim() !== '') {
        payload.user_name = window.WSUserName;
      }
      this.websocket.send(JSON.stringify(payload));
      if(this.listeners[room] === undefined){
        this.listeners[room] = [];
      }
      this.listeners[room].push(listener)
    } else {
      console.warn("Cannot send data with WebSocket when not open.");
    }
  },

  /**
   * Sortir du salon de Websocket.
   * 
   * @param {string} room 
   */
  leave(room) {
    console.log("WebSocket leave");
    if(this.listeners[room] !== undefined){
      this.websocket.send(JSON.stringify({ op: "leave", room: room }));
      delete this.listeners[room];
    }
  }

}

window.WS = WS;